import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/header'
import { columnSalesOrderIgnored } from '@utils/columns'
import { getToday } from '@utils/time'
import Layout from '@components/Layout'
import { useSelector } from 'react-redux'
import ViewSalesModal from '@components/Modal/ViewSalesModal/index'
import { useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { fetchSalesOrderIgnored } from '@utils/fetchData'
import { debouncedSet } from '@utils/debounce'
import SuccessModal from '@components/Modal/SuccessModal'
import ErrorModal from '@components/Modal/ErrorModal'
import CancelSaleModal from '@components/Modal/cancelSaleModal'
import OrderPaymentModal from '@components/Modal/orderPaymentModal'

import {
	handleNavigate,
	handleNavigateCar,
	handleNavigateSeries,
} from '@utils/navigateToPdf'
const IgnoredSalesOrders = () => {
	const { t } = useTranslation()
	const successRef = useRef()
	const errorRef = useRef()
	const dispatch = useDispatch()

	const { department, roleNames } = useSelector((state) => state.main)
	const formattedDate = getToday()

	const [currentPage, setCurrentPage] = useState(0)
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isBtnLoading, setIsBtnLoading] = useState(false)
	const [isCancelModalVisible, setIsCancelModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [docNum, setDocNum] = useState('')
	const [cardName, setCardName] = useState('')
	const [slpName, setSlpName] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(formattedDate)
	const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false)
	const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false)

	const {
		data = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: [
			'salesOrderIgnored',
			currentPage,
			cardName,
			docNum,
			startDate,
			endDate,
			slpName,
			'Ignored',
			roleNames.includes('Supplier') ||
			roleNames.includes('admin') ||
			roleNames.includes('Sales Manager')
				? ''
				: department,
		],
		queryFn: fetchSalesOrderIgnored,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleRowClick = (record) => {
		setSelectedRowData(record)
		setIsModalVisible(true)
	}

	const handleIgnoreClick = (record) => {
		setSelectedRowData(record)
		setIsCancelModalVisible(true)
	}

	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const handleDocNumChange = (val) => {
		debouncedSet(val, setDocNum)
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setCardName)
	}

	const handleSlpNameChange = (val) => {
		debouncedSet(val, setSlpName)
	}
	const handleOpenPaymentModal = (record) => {
		setSelectedRowData(record)
		setIsPaymentModalVisible(true)
	}

	const columns = columnSalesOrderIgnored(
		t,
		handleRowClick,
		handleDocNumChange,
		handleCardNameChange,
		handleSlpNameChange,
		handleNavigate,
		handleNavigateCar,
		handleIgnoreClick,
		roleNames.includes('admin') ? true : false,
		handleNavigateSeries,
		roleNames.includes('Cashier') || roleNames.includes('admin')
			? true
			: false,
		handleOpenPaymentModal,
	)

	return (
		<Layout>
			<Header
				title={t('ignoredSales')}
				currentPage={currentPage + 1}
				handlePreviousPage={handlePreviousPage}
				handleNextPage={handleNextPage}
				hasMoreData={data.length === 10}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onStartDateChange={handleStartDate}
				onEndDateChange={handleEndDate}
				startDate={startDate}
				endDate={endDate}
				isSticky={false}
				formattedDate={formattedDate}
			/>
			<ViewSalesModal
				visible={isModalVisible}
				data={selectedRowData}
				onClose={() => setIsModalVisible(false)}
				ship={roleNames.includes('admin') ? true : false}
				incoming={roleNames.includes('admin') ? true : false}
			/>

			<CancelSaleModal
				visible={isCancelModalVisible}
				data={selectedRowData}
				onClose={() => {
					setIsCancelModalVisible(false)
					refetch()
				}}
			/>
			<OrderPaymentModal
				visible={isPaymentModalVisible}
				data={selectedRowData}
				onClose={() => setIsPaymentModalVisible(false)}
			/>

			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</Layout>
	)
}

export default IgnoredSalesOrders
